@file:OptIn(InternalResourceApi::class)

package qytqwasm.apps.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.FontResource
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem

private const val MD: String = "composeResources/qytqwasm.apps.generated.resources/"

@delegate:ResourceContentHash(1_159_037_329)
internal val Res.font.HarmonyOS_Sans_SC_Regular: FontResource by lazy {
      FontResource("font:HarmonyOS_Sans_SC_Regular", setOf(
        ResourceItem(setOf(), "${MD}font/HarmonyOS_Sans_SC_Regular.ttf", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-781_651_005)
internal val Res.font.font: FontResource by lazy {
      FontResource("font:font", setOf(
        ResourceItem(setOf(), "${MD}font/font.ttf", -1, -1),
      ))
    }

@InternalResourceApi
internal fun _collectWebMainFont0Resources(map: MutableMap<String, FontResource>) {
  map.put("HarmonyOS_Sans_SC_Regular", Res.font.HarmonyOS_Sans_SC_Regular)
  map.put("font", Res.font.font)
}
